import { useTranslation } from 'next-i18next';

import Banner from '@/shared/components/atoms/Banner';
import { Typography } from '@/shared/components/atoms/Typography';
import { useFreeTrial } from '@/shared/hooks/useFreeTrial';

const DemoBanner = () => {
  const { t } = useTranslation();

  const { exitDemo, canAccessAssets } = useFreeTrial();

  return (
    <Banner bg='bg-tertiary-default'>
      <div className='flex items-center gap-8 text-white'>
        <Typography weight='medium'>{t('Demo Farm')}</Typography>
        {canAccessAssets && (
          <Typography
            variant='caption'
            className='cursor-pointer underline'
            onClick={exitDemo}
          >
            {t('go-to-farm')}
          </Typography>
        )}
      </div>
    </Banner>
  );
};

export default DemoBanner;
